import React from 'react';
import PropTypes from 'prop-types';
import { FormPage } from 'shared';
import { useTranslation } from 'react-i18next';
import { NAME_SPACE } from 'i18n';
import { OpenInNewOutlined } from '@material-ui/icons';
import { useProductionDashboardStyles } from './productionDashboard.styles';
import { settings, KEY_SETTINGS } from 'settings';
import { Button } from 'shared';

export function ProductionDashboard() {
  const classes = useProductionDashboardStyles();
  const { t } = useTranslation(NAME_SPACE.PRODUCTION_DASHBOARD);

  const dashboardUrl = settings.getSetting(KEY_SETTINGS.PRODUCTION_DASHBOARD_URL);

  return (
    <FormPage
      buttons={[
        {
          icon: <OpenInNewOutlined />,
          text: t('common:actions.powerBiLink'),
          onClick: () => window.open(dashboardUrl, '_blank'),
          component: Button
        }
      ]}
    >
      <div className={classes.root}>
        <div className={classes.report}>
          <iframe src={dashboardUrl} frameBorder={0} allowFullScreen={true} title={t('name')}></iframe>
        </div>
      </div>
    </FormPage>
  );
}

ProductionDashboard.propTypes = {
  pageTitle: PropTypes.string
};
